module.exports = __webpack_public_path__ + "img/17846_S.c5e8fbe5.png";